<script setup lang="ts">
import type { AccordionTriggerProps } from "reka-ui";
import type { HTMLAttributes } from "vue";
import { reactiveOmit } from "@vueuse/core";
import { Plus, Minus } from "lucide-vue-next";
import { AccordionHeader, AccordionTrigger } from "reka-ui";
import { cn } from "@/utils/shadcn";

const props = defineProps<
  AccordionTriggerProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <AccordionHeader class="flex">
    <AccordionTrigger
      data-slot="accordion-trigger"
      v-bind="delegatedProps"
      :class="
        cn(
          'group/trigger cursor-pointer focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start gap-4 rounded-md py-4 text-left font-sans heading-5 font-bold transition-all outline-none hover:underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50',
          props.class,
        )
      "
    >
      <slot name="icon">
        <Plus
          class="pointer-events-none size-6 stroke-4 shrink-0 translate-y-0.5
           group-data-[state=open]/trigger:hidden"
        />
        <Minus
          class="pointer-events-none size-6 stroke-4 shrink-0 translate-y-0.5
           hidden group-data-[state=open]/trigger:block"
        />
      </slot>

      <slot />
    </AccordionTrigger>
  </AccordionHeader>
</template>
